import type { SimpleIcon } from "simple-icons";
import {
  siBootstrap,
  siCmake,
  siCplusplus,
  siCss3,
  siDocker,
  siDrizzle,
  siExpress,
  siHtml5,
  siJavascript,
  siLaravel,
  siLinux,
  siMacos,
  siNestjs,
  siNextdotjs,
  siNodedotjs,
  siNuxtdotjs,
  siOllama,
  siPhp,
  siPrisma,
  siPython,
  siQt,
  siReact,
  siRust,
  siTailwindcss,
  siTauri,
  siTrpc,
  siTurborepo,
  siTypescript,
  siUbuntu,
  siVite,
  siVuedotjs,
  siWebpack,
} from "simple-icons";

export type Stack = Record<string, SimpleIcon>;

export const STACKS: Stack = {
  PHP: siPhp,
  JavaScript: siJavascript,
  TypeScript: siTypescript,
  "Next.js": siNextdotjs,
  "React.js": siReact,
  TailwindCSS: siTailwindcss,
  Bootstrap: siBootstrap,
  Laravel: siLaravel,
  Vite: siVite,
  Prisma: siPrisma,
  "Vue.js": siVuedotjs,
  "Nuxt.js": siNuxtdotjs,
  "Node.js": siNodedotjs,
  Webpack: siWebpack,
  CSS: siCss3,
  Express: siExpress,
  HTML: siHtml5,
  "C++": siCplusplus,
  Qt: siQt,
  CMake: siCmake,
  Docker: siDocker,
  Python: siPython,
  NestJS: siNestjs,
  Turborepo: siTurborepo,
  Trpc: siTrpc,
  Drizzle: siDrizzle,
  Ollama: siOllama,
  Rust: siRust,
  Ubuntu: siUbuntu,
  Linux: siLinux,
  macOS: siMacos,
  Tauri: siTauri,
};
